import { useState, useRef } from "react";
import { Form, Row, Card, Button } from "antd";
import axios from "axios";
import FormField from "@/components/FormField";
import biFormFields from "@/config/programs/biFormFields";
import dayjs from "dayjs";
import { generatePDF } from "./request-pdf";
import useGlobalConfig from "@/store/global";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import biFormTitles from "@/config/programs/biFormTitles";
import { useEffect } from "react";

const BiRequest = () => {
  const [toast, contextHolder] = notification.useNotification();
  const themeColor = localStorage.getItem("themeColor");
  const { program } = useGlobalConfig();
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const cardRef = useRef(null);

  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const navigate = useNavigate();

  const formFields = biFormFields[program?.name];

  // NOTE: may this is needed for the future
  const downloadPDF = async () => {
    try {
      setDownloading(true);
      const values = await form.getFieldsValue();

      const formatValue = (value) => {
        // Check if value is a dayjs object
        if (value && value.$d) {
          return dayjs(value).format("MM-DD-YYYY");
        }
        // Return regular values as is
        return value;
      };

      console.log("values: ", values);
      const pdfFields = [
        {
          title: "Requestor Information",
          fields: [
            {
              label: "Requestor Name",
              value: formatValue(values.requestor_name),
              span: 12,
            },
            {
              label: "Email",
              value: formatValue(values.requestor_email),
              span: 12,
            },
            {
              label: "Phone",
              value: formatValue(values.requestor_phone),
              span: 12,
            },
            {
              label: "Fax",
              value: formatValue(values.requestor_fax),
              span: 12,
            },
          ],
        },
        {
          title: "Patient Information",
          fields: [
            {
              label: "Patient Name",
              value: formatValue(values.patient_name),
              span: 8,
            },
            {
              label: "Date of Birth",
              value: formatValue(values.patient_dob),
              span: 8,
            },
            {
              label: "Gender",
              value: values.patient_gender == 1 ? "Male" : "Female",
              span: 8,
            },
            {
              label: "Address",
              value: formatValue(values.patient_address),
              span: 24,
            },
            {
              label: "City",
              value: formatValue(values.patient_city),
              span: 6,
            },
            {
              label: "State",
              value: formatValue(values.patient_state),
              span: 6,
            },
            {
              label: "Zip",
              value: formatValue(values.patient_zip),
              span: 6,
            },
            {
              label: "Phone",
              value: formatValue(values.patient_phone),
              span: 6,
            },
          ],
        },
        {
          title: "Payer Information",
          fields: [
            {
              label: "PRIMARY INSURANCE",
              value: "",
              span: 24,
              isSubheader: true,
            },
            {
              label: "Participating Provider",
              value: formatValue(values.insurance_primary_provider),
              span: 12,
            },
            {
              label: "Payer Phone",
              value: formatValue(values.insurance_primary_payer_phone),
              span: 12,
            },
            {
              label: "Policy Number",
              value: formatValue(values.insurance_primary_policy_number),
              span: 12,
            },
            {
              label: "Group Number",
              value: formatValue(values.insurance_primary_group_number),
              span: 12,
            },
            {
              label: "Policy Holder Name",
              value: formatValue(values.insurance_primary_policy_holder_name),
              span: 24,
            },
            {
              label: "SECONDARY INSURANCE",
              value: "",
              span: 24,
              isSubheader: true,
            },
            {
              label: "Participating Provider",
              value: formatValue(values.insurance_secondary_provider),
              span: 8,
            },
            {
              label: "Payer Phone",
              value: formatValue(values.insurance_secondary_payer_phone),
              span: 12,
            },
            {
              label: "Policy Number",
              value: formatValue(values.insurance_secondary_policy_number),
              span: 12,
            },
            {
              label: "Group Number",
              value: formatValue(values.insurance_secondary_group_number),
              span: 12,
            },
            {
              label: "Policy Holder Name",
              value: formatValue(values.insurance_secondary_policy_holder_name),
              span: 24,
            },
          ],
        },
        {
          title: "Physician and Facility Information",
          fields: [
            {
              label: "Physician Name",
              value: formatValue(values.physician_name),
              span: 12,
            },
            {
              label: "Specialty",
              value: formatValue(values.physician_specialty),
              span: 12,
            },
            {
              label: "Physician NPI",
              value: formatValue(values.physician_npi),
              span: 8,
            },
            {
              label: "Tax ID",
              value: formatValue(values.physician_fax),
              span: 8,
            },
            {
              label: "Medicaid Provider",
              value: formatValue(values.physician_medicaid_provider),
              span: 8,
            },
            {
              label: "Facility Name",
              value: formatValue(values.facility_name),
              span: 24,
            },
            {
              label: "Address",
              value: formatValue(values.facility_address),
              span: 24,
            },
            {
              label: "City",
              value: formatValue(values.facility_city),
              span: 8,
            },
            {
              label: "State",
              value: formatValue(values.facility_state),
              span: 8,
            },
            {
              label: "Zip",
              value: formatValue(values.facility_zip),
              span: 8,
            },
            {
              label: "Facility NPI",
              value: formatValue(values.facility_npi),
              span: 8,
            },
            {
              label: "Tax ID",
              value: formatValue(values.facility_tax_id),
              span: 8,
            },
            {
              label: "Medicaid Provider",
              value: formatValue(values.facility_medicaid_provider),
              span: 8,
            },
          ],
        },
        {
          title: "Prescription Information",
          fields: [
            {
              label: "Product Name",
              type: "checkbox-group",
              options:
                program?.name === "nuwiq" || program?.name === "wilate"
                  ? [
                      {
                        label: "NUWIQ (Antihemophilic Factor [Recombinant])",
                        value: "nuwiq",
                        checked: values.program_id === 19,
                      },
                      {
                        label:
                          "wilate (von Willebrand Factor/Coagulation Factor VIII Complex [Human])",
                        value: "wilate",
                        checked: values.program_id === 21,
                      },
                    ]
                  : program?.name === "octagam" ||
                      program?.name === "cutaquig" ||
                      program?.name === "panzyga"
                    ? [
                        {
                          label:
                            "octagam (Immune Globulin Intravenous [Human] - 5% or 10% Liquid Preparation)",
                          value: "octagam",
                          checked: values.program_id === 22,
                        },
                        {
                          label:
                            "cutaquig (Immune Globulin Subcutaneous [Human] - hipp, 16.5% solution)",
                          value: "cutaquig",
                          checked: values.program_id === 17,
                        },
                        {
                          label:
                            "panzyga (Immune Globulin Intravenous [Human] - ifas 10% Liquid Preparation)",
                          value: "panzyga",
                          checked: values.program_id === 20,
                        },
                      ]
                    : [
                        {
                          label: "fibryga (Fibrinogen [Human])",
                          value: "fibryga",
                          checked: values.program_id === 18,
                        },
                      ],
              span: 24,
            },
            {
              label: "ICD-10-CM Code(s)",
              value: formatValue(values.prescription_icd10_code),
              type: "text",
              span: 24,
            },
            {
              label: "Patient Site of Care",
              type: "checkbox-group",
              options: [
                {
                  label: "Hospital Inpatient",
                  value: "hospital_inpatient",
                  checked:
                    values.prescription_patient_site_of_care ===
                    "hospital_inpatient",
                },
                {
                  label: "Hospital Outpatient",
                  value: "hospital_outpatient",
                  checked:
                    values.prescription_patient_site_of_care ===
                    "hospital_outpatient",
                },
                {
                  label: "Physician Office",
                  value: "physician_office",
                  checked:
                    values.prescription_patient_site_of_care ===
                    "physician_office",
                },
                {
                  label: "Home Infusion",
                  value: "home_infusion",
                  checked:
                    values.prescription_patient_site_of_care ===
                    "home_infusion",
                },
                {
                  label: "Other",
                  value: "other",
                  checked: values.patient_site_of_care === "other",
                  hasInput: true,
                  otherValue: values.other_site_of_care_specify,
                },
              ],
              span: 24,
            },
            {
              label: "Dose",
              value: formatValue(values.prescription_dose),
              type: "text",
              span: 12,
            },
            {
              label: "Buy and Bill",
              type: "radio-group",
              options: [
                {
                  label: "Yes",
                  value: "yes",
                  checked: values.prescription_buy_and_bill === true,
                },
                {
                  label: "No",
                  value: "no",
                  checked: values.prescription_buy_and_bill === false,
                },
              ],
              span: 12,
            },
            {
              label: "Directions",
              value: formatValue(values.prescription_directions),
              type: "textarea",
              span: 24,
            },
          ],
        },
        {
          title: "Authorization for Release",
          fields: [
            {
              type: "typography",
              title: "Healthcare Provider Signature (Required)",
              content:
                "By signing below, I certify that I have obtained a valid authorization from the patient listed on this form, permitting me to release the patient's protected health information to Factor My Way, Octapharma, and/or to its contractors as necessary to obtain insurance coverage and payment information regarding NUWIQ® or wilate®.",
              span: 24,
            },
            {
              label: "Signature of Qualified Healthcare Professional",
              value: formatValue(values.healthcare_provider_signature),
              type: "text",
              span: 18,
            },
            {
              label: "Date",
              value: formatValue(values.healthcare_provider_signature_date),
              type: "text",
              span: 6,
            },
            {
              type: "typography",
              title: "Patient Signature (Optional)",
              content:
                "By signing this authorization, I, the patient, authorize my healthcare provider to use and/or disclose protected health information (PHI) related to NUWIQ® or wilate® from my health records and insurance information to Factor My Way, Octapharma, and/or to its contractors as necessary to obtain insurance coverage and payment information. I understand that the information I authorize a person or entity to disclose may be shared with other people or entities and will no longer be protected by federal privacy regulations. I understand that if I choose to revoke this authorization, I must do so in writing to my healthcare provider.",
              span: 24,
            },
            {
              label: "Signature of Patient or Guardian",
              value: formatValue(values.patient_signature),
              type: "text",
              span: 18,
            },
            {
              label: "Date",
              value: formatValue(values.patient_signature_date),
              type: "text",
              span: 6,
            },
          ],
        },
      ];

      const blob = await generatePDF(
        pdfFields,
        biFormTitles[program?.name] || "",
      );
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.download = `${biFormTitles[program.name] || ""}.pdf`;

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error({
        message: "Error generating PDF",
        description: "Please try again",
      });
      console.error("Error generating PDF:", error);
    } finally {
      setDownloading(false);
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          setLoading(true);

          const formData = new FormData();
          Object.keys(values).forEach((key) => {
            // if (key === "signed_pdf_file" || key === "insurance_card") {
            if (key === "insurance_card") {
              const fileList = values[key];
              if (fileList?.[0]?.originFileObj) {
                formData.append(key, fileList[0].originFileObj);
              }
            } else if (key === "licensed_prescriber_signature_date") {
              formData.append(key, dayjs(new Date()).format("YYYY-MM-DD"));
              // } else if (key === "patient_signature_date") {
              // formData.append(key, dayjs(new Date()).format("YYYY-MM-DD"));
            } else if (key === "patient_dob") {
              formData.append(
                key,
                dayjs(new Date(values[key])).format("YYYY-MM-DD"),
              );
            } else if (key === "prescription_is_used") {
              formData.append(key, values[key] === "1" ? true : false);
            } else {
              formData.append(key, values[key]);
            }
          });

          const { data } = await axios.post(
            `/benefit_investigation_requests`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          toast.success({
            message: "Request submitted successfully",
            description: "Your request has been submitted successfully",
          });
          form.resetFields();
          navigate(-1);
        } catch (error) {
          toast.error({
            message: "Request submission failed",
            description: "Please try again",
          });
          console.error(error);
        } finally {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  useEffect(() => {
    form.setFieldValue('licensed_prescriber_signature_date', dayjs())
  }, [])

  return (
    <>
      {contextHolder}
      <Card className="my-10 bg-white print:my-0 print:border-none print:p-0">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          className="mt-10 bg-white"
        >
          <div className="" ref={cardRef}>
            <h3
              className="mb-10 border-b pb-6 text-center text-xl md:text-3xl font-bold text-[#284095]"
              style={{ color: themeColor }}
            >
              {biFormTitles[program?.name] || ""}
            </h3>

            {formFields.map((section) => (
              <div>
                <div
                  className="bg-[#20419b] px-2 text-xl font-semibold uppercase text-white"
                  style={{ backgroundColor: themeColor }}
                >
                  {section.title}
                </div>
                <Row gutter={[16, 0]} className="mt-4">
                  {section.fields.map((field) => (
                    <FormField key={field.name} field={field} />
                  ))}
                </Row>
              </div>
            ))}
          </div>
          <div className="mt-10 grid grid-cols-7 gap-4 print:hidden">
            {/*<Button*/}
            {/*  color="default"*/}
            {/*  variant="outlined"*/}
            {/*  onClick={downloadPDF}*/}
            {/*  size="large"*/}
            {/*  disabled={downloading}*/}
            {/*  loading={downloading}*/}
            {/*  className="w-full"*/}
            {/*>*/}
            {/*  Download PDF with the entered details*/}
            {/*</Button>*/}
            <Button
              className="col-span-3 col-start-3 w-full"
              type="primary"
              size="large"
              disabled={loading}
              loading={loading}
              onClick={handleSubmit}
              style={{
                backgroundColor: themeColor,
              }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default BiRequest;
